export function HasInline(type, value) {
  return value.inlines.some(inline => inline.type === type);
}
